export enum PaymentProcessor {
  STRIPE = "STRIPE",
  PAY360 = "PAY360",
  SQUARE = "SQUARE",
}
export enum OnboardingSource {
  BARCLAYCARD = "BARCLAYCARD",
  YOELLO = "YOELLO",
  RMS = "RMS",
  CARDSAVER = "CARD_SAVER",
  WORLDPAY = "WORLDPAY",
  DELIVERECT = "DELIVERECT",
  NCR = "NCR",
  BNA = "BNA",
  ORACLE = "ORACLE",
  ZONAL = "ZONAL",
  TEVALIS = "TEVALIS"
}
export enum AcquirerName {
  BARCLAYCARD = "barclaycard",
  WORLDPAY = "worldpay",
}
export enum PaymentsStatus {
  Inactive = "Inactive",
  Active = "Active",
  Inprogress = "Inprogress",
}
export interface Step {
  /** Wizard main title and description */
  main: {
    title: string;
    description: string;
  };
  /** Wizard step indication, including a text and an icon */
  indicator: {
    icon: string;
    text: string;
  };
  /** Whether or not to show wizard steps */
  showSteps: boolean;
  /** Wizard title */
  title: string;
  /** Wizard caption */
  caption: JSX.Element;
  /** Wizard JSX content */
  content: JSX.Element;
  /** A button displayed under each wizard step */
  button: {
    text: string;
    url: string;
    target: string;
    disabled?: boolean;
    icon?: JSX.Element;
  };
}
